import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="loader mx-auto mb-4"></div>
        <p className="text-gray-600">Cargando rifa...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;